<div class="timeline-scale">
  <app-timeline-slider>
    <app-timeline-scale-tick *ngFor="let position of tickPositions" [position]="position"></app-timeline-scale-tick>
  </app-timeline-slider>
</div>



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-scale/timeline-scale.component.html